import {
  RemoveEmployeeLifecycleStepActionDocumentDocument,
  UploadEmployeeLifecycleStepActionDocumentsDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

/**
 * Upload / remove documents for an `upload_document` StepAction.
 *
 * Both mutations return the updated `stepAction { id uploadedDocuments }`,
 * which Apollo normalises into the cache by id — so the inbox taskable (the
 * same EmployeeLifecycleStepAction entity) re-renders with the new file list
 * without an explicit cache write.
 */
export const useUploadDocument = (stepActionId: string) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const [uploadDocuments] = useMutation(UploadEmployeeLifecycleStepActionDocumentsDocument, {
    extractorFn: (data) => data.employeeLifecycleMutations.uploadEmployeelifecycleStepAction,
  })
  const [removeDocument] = useMutation(RemoveEmployeeLifecycleStepActionDocumentDocument, {
    extractorFn: (data) => data.employeeLifecycleMutations.removeFileEmployeelifecycleStepAction,
  })

  const addFiles = async (files: File[]) => {
    if (files.length === 0) return

    await uploadDocuments({
      variables: { companyId, id: stepActionId, files },
    })
  }

  const removeFile = async (fileId: string) => {
    await removeDocument({
      variables: { companyId, id: stepActionId, fileId },
    })
  }

  return { addFiles, removeFile }
}
